// export const SERVER = "https://192.168.0.24:3001/api/";
export const SERVER = "/api/";

// export const SERVER_IP = "https://192.168.0.24:3001";
// export const SERVER_IP = "https://opic-demo.tkita.info";
export const SERVER_IP = "https://ai-sliedu.com";
